export default {
  name: 'RankingList',
  props: ['title', 'list']
};